import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";

export const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        py: { xs: 8, md: 12 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant={isMobile ? "h3" : "h2"}
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          Título Principal Impactante
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          paragraph
          sx={{ mb: 4, fontWeight: 400 }}
        >
          Descreva brevemente sua oferta ou proposta de valor de forma clara e
          concisa. Destaque os benefícios principais.
        </Typography>
        <Button variant="contained" color="primary" size="large" href="#cta">
          Chamada para Ação Principal
        </Button>
      </Container>
    </Box>
  );
};
